import { proxy } from "valtio";

export const editapprovalStore = proxy({
quote:{},
editquote:{},
list:[],
pkb:[],
rebate:[],
approve:true
})